import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
export default {
  computed: {
    ...walletVuex.mapState(["isMobile", "netId", "isWallet"])
  },
  methods: {
    ...userVuex.mapActions(["getLoginInfo"])
  },
  async mounted() {
    setTimeout(async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const state = urlParams.get('state');
      const code = urlParams.get('code');
      if (!code || !state) {
        this.$router.push("/");
      } else {
        const res = await this.$http.post("auth/twitter/callback", {
          code: code,
          state: state
        });
        if (res.code == 0) {
          const pushPath = localStorage.getItem("twitter_callback_path");
          setTimeout(() => {
            if (pushPath) location.href = pushPath;else this.$router.push("/");
          }, 1000);
        } else {
          this.$toasted.error(res.message);
          const pushPath = localStorage.getItem("twitter_callback_path");
          setTimeout(() => {
            if (pushPath) location.href = pushPath;else this.$router.push("/");
          }, 1000);
        }
      }
    }, 200);
  }
};